import { connect } from 'react-redux';
import Welcome from '../../../components/login/Welcome';
import {
  getCSRFToken,
  getSessionCookie,
  resolveTenant,
} from 'core/slices/session';
import { getWelcomeMessage } from 'core/slices/welcome';
import {
  isLoadingSession,
  hasSessionCookie,
  hasSessionError,
  welcomeMessage,
} from 'core/selectors';

export default connect(
  state => ({
    isLoadingSession: isLoadingSession(state),
    hasSessionCookie: hasSessionCookie(state),
    hasSessionError: hasSessionError(state),
    welcomeMessage: welcomeMessage(state),
  }),
  { getCSRFToken, getSessionCookie, getWelcomeMessage, resolveTenant },
)(Welcome);
